import { KeyValuePair } from '../../models';

// Only handle simple enumeration
export class EnumHelpers {
    // No instances guard.
    private constructor() { }

    // Get values array from enumeration.
    public static Values(enumType: object): string[] {
        return Object
            .keys(enumType)
            .map(key => enumType[key])
            .filter(value => typeof value === 'string') as string[];
    }

    // Get values array from enumeration.
    public static Keys(enumType: object): number[] {
        return Object
            .keys(enumType)
            .map(k => parseInt(k, 10))
            .filter(k => !isNaN(k));
    }

    // Get keyvaluepair from enum
    public static KeyValues(enumType: object): KeyValuePair<number, string>[] {
        return EnumHelpers
            .Keys(enumType)
            .map(k => {
                return { key: k, value: enumType[k] };
            });
    }
}